export const GET_ALL_REGEX = 'GET_ALL_REGEX'
export const GET_SPECIFIC_REGEX = 'GET_SPECIFIC_REGEX'
